import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';

@Component({
  selector: 'app-activate-embedded-org-dialog',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule
  ],
  templateUrl: './activate-embedded-org-dialog.component.html',
  styleUrl: './activate-embedded-org-dialog.component.scss'
})
export class ActivateEmbeddedOrgDialogComponent {

  formControl!: FormGroup;
  showConfirmationCheckbox: boolean = false;
  confirmSubmit: boolean = false;
  minDate!: Date;
  maxDate!: Date;

  constructor(
    public dialogRef: MatDialogRef<ActivateEmbeddedOrgDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initForm();
    this.setValidDateRanges();
  }

  initForm() {
    this.formControl = this.formBuilder.group({
      organization_id: [this.data.organizationId],
      organization_name: [this.data.name],
      pms: [this.data.partnerId],
      partner_id: [this.data.referenceId],
      activation_date: ['', [Validators.required, Validators.pattern(/[\S]/)]]
    });
  }

  setValidDateRanges() {
    this.maxDate = new Date();
    const requestStartDate = moment.utc(this.data.requestStartDate).subtract(1, 'day');
    this.minDate = new Date(requestStartDate.year(), requestStartDate.month(), requestStartDate.date());
  }

  onSaveClick(): void {
    let payload = {
      organization_id: this.formControl.get('organization_id')?.value,
      organization_name: this.formControl.get('organization_name')?.value,
      pms: this.formControl.get('pms')?.value,
      partner_id: this.formControl.get('partner_id')?.value,
      activation_date: this.formControl.get('activation_date')?.value
    }
    this.dialogRef.close(payload);
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  onActivationDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (this.isActivationDateFiveDaysOrMore(event.value)) {
      this.showConfirmationCheckbox = true;
      this.confirmSubmit = false;
    } else {
      this.showConfirmationCheckbox = false;
      this.confirmSubmit = true;
    }
  }

  isActivationDateFiveDaysOrMore(selectedActivationDate: any): boolean {
    const activationRequestDate = new Date(selectedActivationDate);
    activationRequestDate.setHours(0, 0, 0, 0);

    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(new Date().getDate() - 5);
    fiveDaysAgo.setHours(0, 0, 0, 0);

    const dateToCheck = new Date(selectedActivationDate);
    dateToCheck.setHours(0, 0, 0, 0);

    return dateToCheck.getTime() <= fiveDaysAgo.getTime();
  }

  onConfirmCheckboxChange(event: MatCheckboxChange): void {
    if (event.checked) {
      this.confirmSubmit = true;
    } else {
      this.confirmSubmit = false;
    }
  }
}